var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('init-info',[_c('v-btn',{attrs:{"color":"secondary","to":_vm.qrCardreadTo}},[_vm._v("Start QR kode scanner →")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","to":_vm.cancelTo,"active-class":""}},[_vm._v("Avbryt")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }